import { UserAuditLogEntry } from 'apis/auditLogs';

import { UserActivityCard } from './userActivityCard';
import { statusColors } from './userActivityTypes.utils';

type UserAddedProps = {
  entry: UserAuditLogEntry<'USER_ADDED'>;
};

export const UserAdded = ({ entry }: UserAddedProps): JSX.Element => {
  const fields = [
    {
      label: 'Display name',
      value: entry.name,
    },
    {
      label: 'User type',
      value: entry.user_type,
    },
  ];

  if (entry.company_id) {
    fields.push({
      label: 'Company id',
      value: entry.company_id,
    });
  }

  return (
    <UserActivityCard
      entry={entry}
      color={statusColors.positive}
      icon="user-plus"
      title="Created"
      fields={fields}
    />
  );
};
